module.exports = __webpack_public_path__ + "img/009.a3a43e09.png";